<template>
  <Radar id="my-chart-id" :options="options" :data="chartData" />
</template>

<script setup>
import { Radar } from "vue-chartjs";
import { onMounted } from "vue";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  LineElement,
  PointElement,
  Filler,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
);

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
  aspectRatio: {
    type: Object,
    required: false,
    default: null,
  },
});

onMounted(() => {
  // if (this.aspectRatio) {
  //   this.$refs.canvas.width = this.aspectRatio.width
  //   this.$refs.canvas.height = this.aspectRatio.height
  // }
  // this.renderChart(this.chartData, this.options)
});
</script>
